import {Injectable} from '@angular/core';
import {custom_env} from './../../_custom_enviroment';

@Injectable()
export class EnvironmentService {

    protected environment: {
        api_url: '',
        app_name: ''
    };

    constructor() {
        const host = window.location.host;
        this.environment = (custom_env.hasOwnProperty(host)) ? custom_env[host] : custom_env['dev'];
    }

    getApiUrl(): string {
        return this.environment.api_url;
    }

    getAppName(): string {
        return this.environment.app_name;
    }

}



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/core/service/environment.service.ts